import React, { useState } from "react";
import PropTypes from "prop-types";
import SeverityCell from "../../../customAssets/severityCell.js"; // Adjust path if necessary

// This function now receives `record` dynamically
export const getCodeData = (record) =>
  Object.entries(record.code_analysis || {}).map(
    ([codeItem, details], index) => {
      const { cwe, "owasp-mobile": owaspMobile, masvs } = details.metadata;

      const standards = [
        cwe ? `<strong>CWE:</strong> ${cwe}<br/>` : "",
        owaspMobile ? `<strong>OWASP Mobile:</strong> ${owaspMobile}<br/>` : "",
        masvs ? `<strong>MASVS:</strong> ${masvs}<br/>` : "",
      ]
        .filter(Boolean) // Remove empty values
        .join("");

      return {
        id: index,
        issue: details.metadata.description,
        severity: details.metadata.severity,
        standards: standards || "N/A", // Default to "N/A" if all are empty
        files: { name: codeItem, list: Object.keys(details.files || {}) },
      };
    }
  );

const StandardsCell = ({ value }) => (
  <div dangerouslySetInnerHTML={{ __html: value }} />
);

StandardsCell.propTypes = {
  value: PropTypes.string,
};

// Expandable FilesCell Component
const FilesCell = ({ value }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const fileCount = value.list.length;

  return (
    <div>
      <strong>{value.name}</strong>
      {fileCount > 0 && (
        <>
          <div style={{ marginTop: ".2em" }}>
            <button onClick={() => setIsExpanded(!isExpanded)}>
              {isExpanded ? "Hide Files" : `Ver ${fileCount} Archivos`}
            </button>
          </div>
          {isExpanded && (
            <ul>
              {value.list.map((file, idx) => (
                <li key={idx}>{file}</li>
              ))}
            </ul>
          )}
        </>
      )}
    </div>
  );
};

FilesCell.propTypes = {
  value: PropTypes.shape({
    name: PropTypes.string.isRequired,
    list: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
};

// Static columns definition
export const codeColumns = [
  {
    Header: "Issue",
    accessor: "issue",
  },
  {
    Header: "Severity",
    accessor: "severity",
    Cell: SeverityCell,
  },
  {
    Header: "Standards",
    accessor: "standards",
    Cell: StandardsCell,
  },
  {
    Header: "Files",
    accessor: "files",
    Cell: FilesCell,
  },
];

export const codeTitle = "category-title-code";
